import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M5.33333 1.33337C5.70152 1.33337 6 1.63185 6 2.00004V2.66671H10V2.00004C10 1.63185 10.2985 1.33337 10.6667 1.33337C11.0349 1.33337 11.3333 1.63185 11.3333 2.00004V2.66671H12C13.1046 2.66671 14 3.56214 14 4.66671V12C14 13.1046 13.1046 14 12 14H4C2.89543 14 2 13.1046 2 12V4.66671C2 3.56214 2.89543 2.66671 4 2.66671H4.66667V2.00004C4.66667 1.63185 4.96514 1.33337 5.33333 1.33337ZM4 4.00004C3.63181 4.00004 3.33333 4.29852 3.33333 4.66671V12C3.33333 12.3682 3.63181 12.6667 4 12.6667H12C12.3682 12.6667 12.6667 12.3682 12.6667 12V4.66671C12.6667 4.29852 12.3682 4.00004 12 4.00004H4ZM7.99943 6.00004C8.36762 6.00004 8.6661 6.29852 8.6661 6.66671V7.66671H9.66667C10.0349 7.66671 10.3333 7.96518 10.3333 8.33337C10.3333 8.70156 10.0349 9.00004 9.66667 9.00004H8.6661V10C8.6661 10.3682 8.36762 10.6667 7.99943 10.6667C7.63124 10.6667 7.33276 10.3682 7.33276 10V9.00004H6.33333C5.96514 9.00004 5.66667 8.70156 5.66667 8.33337C5.66667 7.96518 5.96514 7.66671 6.33333 7.66671H7.33276V6.66671C7.33276 6.29852 7.63124 6.00004 7.99943 6.00004Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }